// lbl.home
export const home = {
    title: "สวัสดี โลก!",
    insuranceExpire: 'กรมธรรม์ของคุณกำลังจะหมดอายุ',
    viewInsurance: 'ดูข้อมูลกรมธรรม์',
    privildges_foryou: 'สิทธิพิเศษสำหรับคุณ',
    deals_foryou: 'ดีลพิเศษเฉพาะคุณ',
    no_data: 'ไม่มีข้อมูล',
    input_field: 'กรุณาระบุฟิลด์ให้ครบ',
    password_format: 'กรุณาระบุรูปแบบรหัสผ่านให้ถูกต้อง',
    password_not_match: 'รหัสผ่านไม่ตรงกัน',
    more_information: 'ติดต่อสอบถามข้อมูลเพิ่มเติมได้ที่',
    title_logout: 'ยืนยันออกจากระบบ ? ',
    confirm_logout: 'ท่านต้องการออกจากระบบหรือไม่ ? ',
    login: {
        register_login: 'ลงทะเบียน/เข้าสู่ระบบ',
        place_username: 'กรอกเบอร์โทรศัพท์',
        mobile_incorrect: 'กรุณากรอกข้อมูลให้ถูกต้อง',
        confirm: 'ยืนยัน',
        or: 'หรือ',
        login_line: 'เข้าสู่ระบบด้วย Line',
        login_facebook: 'เข้าสู่ระบบด้วย Facebook',
        cant_login: 'หากเข้าสู่ระบบไม่ได้กรุณาติดต่อเจ้าหน้าที่',
        enter_password: 'กรอกรหัสผ่าน',
        enter_pincode: 'กรอกรหัส PIN Code',
        condition_password: 'รหัสผ่านประกอบด้วย 8-20 ตัวอักษร โดยต้องใช้อักษรตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่ และตัวเลข',
        condition_pincode: 'รหัสผ่านประกอบด้วยตัวเลข 0-9 จำนวน 8 ตัว',
        password_incorrect: 'กรุณากรอกข้อมูลให้ถูกต้อง',
        login: 'เข้าสู่ระบบ',
        please_login: 'กรุณาเข้าสู่ระบบ'
    },

    tab_menu: {
        main: 'หน้าหลัก',
        privilege: 'สิทธิพิเศษ',
        history: 'ประวัติคะแนน',
        profile: 'โปรไฟล์',
        profile_edit: 'แก้ไขโปรไฟล์',
        deals_for_you: 'ดีลพิเศษเฉพาะคุณ',
        mission: 'ภารกิจ'
    },
};
